import { getJson, postJson } from 'utils/http';

import { ApiNotification } from './types/ApiNotification';

export function apiFetchNotifications(): Promise<Array<ApiNotification>> {
  return getJson<{ notifications: ApiNotification[] }>(
    '/data/notifications',
  ).then(({ notifications }) => notifications);
}

export function apiMarkNotificationsAsViewed(notificationIds: Array<string>) {
  return postJson<{ notifications: ApiNotification[] }>(
    '/data/notifications-viewed',
    {
      notificationIds,
    },
  ).then(({ notifications }) => notifications);
}

export function apiMarkNotificationsAsRead(notificationIds: Array<string>) {
  return postJson<{ notifications: ApiNotification[] }>(
    '/data/notifications-read',
    {
      notificationIds,
    },
  ).then(({ notifications }) => notifications);
}

export function apiMarkNotificationsAsDismissed(
  notificationIds: Array<string>,
) {
  return postJson<{ notifications: ApiNotification[] }>(
    '/data/notifications-dismissed',
    {
      notificationIds,
    },
  ).then(({ notifications }) => notifications);
}
